// The gate's rule: where a route change goes while a sync is due. Pure, so
// it is tested without the router or the services.
//
// The gate holds the user on `/sync` only for the account's **first** sync
// (2026-10-19; before that every due day went through the screen, and the
// user asked that "the app doesn't block while new games are loading"). On
// a later day it lets the user through at once: the day's sync runs in the
// background, from the importer, with a toast.

/** Routes the gate leaves alone: the landing page, the sync screen itself, and a review opened by its address (the game it names is already here). */
export function ungated(pathname: string): boolean {
  return pathname === '/welcome' || pathname === '/sync' || pathname.startsWith('/review/');
}

/**
 * Where to send a route change: `/sync` when a sync is due and none ever
 * completed for the account (`first`), nothing otherwise.
 */
export function gateTo(pathname: string, due: boolean, first: boolean): '/sync' | undefined {
  if (ungated(pathname)) return undefined;
  return due && first ? '/sync' : undefined;
}
